// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Print: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M2.604 1.625h5.955l.816.795v1.83H10.5V2.42c0-.298-.119-.584-.33-.795L9.375.83A1.124 1.124 0 008.58.5H2.604c-.6 0-1.104.503-1.104 1.125V4.25h1.125l-.021-2.625zM10.313 5H1.687A1.69 1.69 0 000 6.688v2.625c0 .31.252.562.563.562h1.312v1.875c0 .414.336.75.75.75h6.75a.75.75 0 00.75-.75V9.875h1.313c.31 0 .562-.252.562-.563V6.688A1.69 1.69 0 0010.312 5zM9 11.375H3v-2.25h6v2.25zm1.875-2.625h-.75a.75.75 0 00-.75-.75h-6.75a.75.75 0 00-.75.75h-.75V6.687c0-.31.252-.562.563-.562h8.624c.31 0 .563.252.563.563V8.75z" />
        </svg>
    );
};

export default React.memo(Print);
